import {
  B2BColorConfig,
  defaultB2BColors,
  defaultWithXmodColors,
} from "redmond";

export const colors: B2BColorConfig = defaultB2BColors;
export const xmodColorVars = defaultWithXmodColors;
